<template>
    <div class="local-data">
        <div class="filter-criteria">
            <div class="filter-title">
                <span>操作记录</span>
                <span>/</span>
                <span>导出记录</span>
            </div>
            <div class="filter-content">
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">创建时间：</span>
                        <a-range-picker class="date-range" @change="onChange" style="" format="YYYY-MM-DD HH:mm:ss" />
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">负责人：</span>
                        <a-select placeholder='请选择负责人' @change="changePerson" class="charge-person">
                            <a-select-option :value="item.value" v-for="(item,index) in selectList" :key='index'>
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">状态：</span>
                        <a-select placeholder='请选择状态' @change="chargeState" class="charge-person">
                            <a-select-option value="1">
                                待执行
                            </a-select-option>
                            <a-select-option value="2">
                                执行中
                            </a-select-option>
                            <a-select-option value="3">
                                已完成
                            </a-select-option>
                            <a-select-option value="4">
                                失败
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="table-data">
            <div class="table-content">
               <a-table
                    :data-source="tableData"
                    :pagination="false"
                    :scroll="{ x: 'max-content' }"
                    :rowKey="record => record.id"
                >
                    <a-table-column key="createTime" title="创建时间" data-index="createTime" />
                    <a-table-column key="type" title="导出类型" data-index="type" />
                    <a-table-column key="operator" title="操作人" data-index="operator" />
                    <a-table-column key="dataCount" title="数量" data-index="dataCount" />
                    <a-table-column key="status" title="状态" data-index="status" >
                        <template slot-scope="text, record">
                            <div>
                                <span class="circular" v-if="record.status==1" style="background:rgba(255, 195, 0, 1)"></span>
                                <span class="circular" v-if="record.status==2" style="background:rgba(24, 144, 255, 1)"></span>
                                <span class="circular" v-if="record.status==3" style="background:rgba(67, 207, 124, 1)"></span>
                                <span class="circular" v-if="record.status==4" style="background:rgba(212, 48, 48, 1)"></span>
                                {{ judgeRole(record.status) }}
                            </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="downloadUrl" title="操作" data-index="downloadUrl" >
                        <template slot-scope="text, record">
                            <div v-if="record.status==3" style="cursor:pointer;color:rgba(24, 144, 255, 1)" @click="downloadUrl(record.downloadUrl)">下载</div>
                            <div v-if="record.status!=3" style="color:rgba(0, 0, 0, 0.45);">下载</div>
                        </template>
                    </a-table-column>
                </a-table>
                <div class="pagination-table">
                    <div style="float:left;color:rgba(80, 80, 80, 1);font-size:14px">总计：{{total}}条</div>
                    <a-pagination
                        style="float:right"
                        show-size-changer
                        :total="total"
                        :show-total="total => `共 ${total} 条     `"
                        v-model="currentPage"
                        @change="pageChange"
                        @showSizeChange="onShowSizeChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MonthBill',
        data() {
            return {
                startDate: '',
                endDate: '',
                chargePerson: null,
                selectedRowKeys: [],
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                loading: false,
                currentState: '',
                currentPerson: '',
                selectList: []
            }   
        },
        methods: {
            judgeRole(data) {
                switch (data){
                    case 1:
                        return '待执行'
                    case 2:
                        return '执行中'
                    case 3:
                        return '已完成'
                    default :
                        return '失败'
                }
            },
            onChange(date, dateString) {
                console.log(date, dateString);
                this.startDate = dateString[0]
                this.endDate = dateString[1]
                this.queryBasicData()
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            queryBasicData() {
                this.axios(
                    {
                        method:'get',
                        url:'api/export/list', 
                        params: {
                            userId: this.currentPerson,
                            createTimeStart: this.startDate,
                            createTimeEnd: this.endDate,
                            current: this.currentPage,
                            size: this.pageSize,
                            status: this.currentState
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tableData = response.data.data.records
                        this.total = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            chargeState(value) {
                this.currentState = value
                this.queryBasicData()
            },
            changePerson(value) {
                this.currentPerson = value
                this.queryBasicData()
            },
            querySelectList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user/selectList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.selectList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            downloadUrl(url) {
                window.open(url, '_blank');
            }
        },
        mounted: function() {
            this.querySelectList()
            this.queryBasicData()
        }
    }
</script>

<style scoped lang="less">
    .local-data{
        height: 100%;
        display: flex;
        flex-direction: column;
        .filter-criteria{
            height: 203px;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            margin-top: 1px;
            padding: 15px 24px;
            .filter-title{
                font-size: 14px;
                span:nth-child(1){
                    color: rgba(0, 0, 0, 0.45);
                }
                span:nth-child(2){
                    color: rgba(0, 0, 0, 0.45);
                    margin: 0 6px;
                }
                span:nth-child(3){
                    color: rgba(0, 0, 0, 0.7);
                }
            }
            .filter-content{
                margin-top: 24px;
                .row-list{
                    margin-bottom: 16px;
                    .row-title{
                        display: inline-block;
                        width: 98px;
                    }
                    .charge-person{
                        width: 240px;
                    }
                    .date-range{
                        width: 320px;
                        // margin-left: 24px;
                    }
                    .search-way{
                        width: 240px;
                    }
                }
                .clean-up{
                    float: right;
                    color: rgba(24, 144, 255, 1);
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
        .table-data{
            flex: 1;
            padding: 24px;
            .table-content{
                width: 100%;
                height: 100%;
                background: #fff;
                padding: 24px;
                .table-data{
                    margin-top: 24px;
                }
                .pagination-table{
                    // float: right;
                    padding-top: 24px;
                    width: 100%;
                }
                .circular{
                    width: 8px;
                    height: 8px;
                    border-radius: 4px;
                    margin-right: 8px;
                    display: inline-block;
                }
            }
        }
    }
</style>